
<template>
    <div class="page-class"
        :class="[{'page-mass': theme == 'mass'}, {'page-prestige': theme == 'prestige'},{'page-nomenu': !isHaveMenu}]">
        <keep-alive>
            <router-view :key="$route.fullPath"></router-view>
        </keep-alive>
    </div>
</template>
<script>
export default {
    name: 'Reward',
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    data: function () {
        return {
            isHaveMenu: false
        }
    },
    watch: {
        $route(to) {
            this.setPageClass(to);
        }
    },
    methods: {
        setPageClass: function (to) {
            this.isHaveMenu = (to.name == "reward list");
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
